module.exports = __webpack_public_path__ + "static/media/DQAssessment.2ed2d6d0.png";